import React, { useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  AppBar,
  Badge,
  Box,
  Hidden,
  IconButton,
  Link,
  Toolbar,
  Typography,
  makeStyles
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import NotificationsIcon from '@material-ui/icons/NotificationsOutlined';
import InputIcon from '@material-ui/icons/Input';
import Logo from 'src/components/Logo';
import { adminLogout } from 'src/libs/AdminServices';
import SessionContext from 'src/libs/SessionContext';

const useStyles = makeStyles(() => ({
  root: {},
  avatar: {
    width: 60,
    height: 60
  }
}));

const TopBar = ({
  className,
  onMobileNavOpen,
  ...rest
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [notifications] = useState([]);
  const { userSession, setUserSession } = React.useContext(SessionContext);

  const handleLogout = async () => {
    try {
      const _userSession = {
        isAuthenticated: false,
        isAuthenticating: false,
        showTimeOutLogin: false,
        UserID: '',
        UserName: '',
        UserType: '',
        UserEmail: '',
        Avatar: '',
        token: ''
      };

      const res = await adminLogout();
      setUserSession(_userSession);
      sessionStorage.clear();

      navigate('/login', { replace: true });
    } catch (e) {
      alert('error');
    }
  };

  return (
    <AppBar
      className={clsx(classes.root, className)}
      elevation={0}
      {...rest}
    >
      <Toolbar>
        <RouterLink to="/">
          <Logo />
        </RouterLink>
        <Typography
          align="center"
          color="#FFFFFF"
          gutterBottom
          variant="h2"
        >
          &nbsp;&nbsp;Online Payment Platform
        </Typography>
        <Box flexGrow={1} />
        <Hidden mdDown>
          <IconButton color="inherit">
            <Link color="primary" href="#" onClick={handleLogout}>
              <InputIcon style={{ color: 'white' }} />
            </Link>
          </IconButton>
        </Hidden>
        <Hidden lgUp>
          <IconButton
            color="inherit"
            onClick={onMobileNavOpen}
          >
            <MenuIcon />
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func
};

export default TopBar;
